<div class="mb-5">
  <h1 i18n>User Administration</h1>
  <p class="note py-0 my-0" i18n>Search for a user by name, email or dealer using the search bar below.</p>
  <div>
    <div class="d-flex flex-column flex-md-row w-100 gap-3 m-0 col-12 lg:col-8 xl:col-6 pl-0 pr-3 lg:pr-0">
      <p-inputgroup class="flex-grow-1">
        <p-inputgroup-addon><i class="pi pi-search"></i></p-inputgroup-addon>
        <input pInputText
               type="text"
               (input)="search($event)"
               placeholder="Find by ID, Name, Email Address or Dealer" />
        <button type="button"
                class="p-button flex-shrink-0 merge-left"
                aria-label="Add new user"
                (click)="createUser()"
                (keydown.enter)="createUser()" i18n>
          Create User
        </button>
      </p-inputgroup>
    </div>
    <div class="user-management col-12 mx-auto pl-0 pr-3">
      <p-table
        role="table"
        aria-label="User Table"
        scrollHeight="flex"
        [value]="users"
        [paginator]="false"
        [scrollable]="false"
        [loading]="loading"
        [responsiveLayout]="'stack'"
        styleClass="p-datatable-striped"
        [customSort]="true"
        (sortFunction)="sortBy($event)">

          <ng-template pTemplate="header">
            <tr role="columnheader">
              <th id="userId" pSortableColumn="userId" title="ID of the user" i18n>User ID <p-sortIcon field="userId" /></th>
              <th id="fullName" pSortableColumn="name" i18n title="The user's full name">Full Name <p-sortIcon field="name" /></th>
              <th id="email" pSortableColumn="email" i18n title="The user's email">Email <p-sortIcon field="email" /></th>
              <th id="dealerName" pSortableColumn="dealerName" i18n title="Name of the dealer the user works in">Dealer Name <p-sortIcon field="dealerName" /></th>
              <th id="dealerNo" pSortableColumn="dealerNo" title="The Dealer's ID" i18n>Dealer No. <p-sortIcon field="dealerNo" /></th>
              <th id="active" class="min-w-min" title="Is the account active?"></th>
              <th id="edit" class="min-w-min"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr role="row">
              <td i18n-aria-label aria-label="User ID" role="cell">{{ user.userId }}</td>
              <td i18n-aria-label aria-label="Full Name" role="cell">{{ user.name }}</td>
              <td i18n-aria-label aria-label="Email" role="cell">{{ user.email }}</td>
              <td i18n-aria-label aria-label="Dealer Name" role="cell">{{ user.dealerName }}</td>
              <td i18n-aria-label aria-label="Dealer No." role="cell">{{ user.dealerNo }}</td>
              <td class="w-1rem" i18n-aria-label aria-label="Active or Locked" role="cell">
                <i class="pi {{ user.locked ? 'pi-lock' : 'pi-lock-open' }}"></i>
              </td>
              <td class="flex edit-cog" aria-labelledby="edit">
                <button class="edit-btn p-button-text p-button-icon-only" pButton type="button" (click)="editUser(user.userId)">
                  <i class="pi pi-cog"></i>
                </button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" i18n aria-live="polite">No Users found</td>
            </tr>
          </ng-template>

      </p-table>
    </div>
    <div class="flex-auto">
      <p-paginator (onPageChange)="changePage($event)"
                   [first]="firstRecord"
                   [rows]="pageSize"
                   [totalRecords]="totalRecords"
                   [rowsPerPageOptions]="[3, 25, 50, 100]"></p-paginator>
    </div>
  </div>
</div>
